export const getNestedArray = (array, blockLimit = 10) => {
  const reduceArrayToNestedLevels = (acc, _, index) => {
    const isMultiplyOfValue = (index + 1) % blockLimit === 0;

    if (isMultiplyOfValue) {
      const startBlock = acc.length - 1;
      const newBlock = array.slice(startBlock, index);
      return [...acc, newBlock];
    }

    return acc;
  };

  const nestedLevels = array
    .reduce(reduceArrayToNestedLevels, [[]])
    .filter((block) => block.length > 0);

  const reduceToGetRest = (acc, currentBlock) => {
    const lastBlock = nestedLevels[nestedLevels.length - 1];

    if (!lastBlock) return acc;

    const lastArray = lastBlock[lastBlock.length - 1];

    if (lastArray) {
      const lastArrayOfCatalog = currentBlock
        .map((event, index) => [event, index])
        .find(([event]) => event.id === lastArray.id);

      if (lastArrayOfCatalog) {
        const [, arrayIndex] = lastArrayOfCatalog;
        return array.slice(arrayIndex + 1, array.length - 1);
      }
    }

    return acc;
  };

  const restOfNestedArray = nestedLevels.reduce(reduceToGetRest, []);

  const nestedArrayWithRest = [...nestedLevels, restOfNestedArray];
  return nestedArrayWithRest;
};
